/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  
  const cartQuickViewLinks = document.querySelectorAll('.vd-link');
  if (cartQuickViewLinks.length) {
    cartQuickViewLinks.forEach((link) => {
      const handleEvent = (e) => {
        e.preventDefault(); // Prevent default action (e.g., following a link)
        let productId = link.dataset.productId;
        let quickViewEl = document.querySelector(`.cart-item-popup-indv-${productId}`);
        if (quickViewEl) {
          quickViewEl.classList.add('active');
        }
      };
  
      link.addEventListener('click', handleEvent);
      link.addEventListener('touchstart', handleEvent); // Handle touch events for better iOS support
    });
  }
	



  // Collection cards: size each row from its own cards (rules in custom.css, "Row-aware card spacing").
  // The pill hugs its title; cards shorter than the tallest in their row get the difference as
  // spare space under their pill (or under their title when they have no pill), so prices line up.
  (function () {
    var grids = document.querySelectorAll('.template-collection #CollectionLoop');
    if (!grids.length) return;

    function numeric(value) {
      return parseFloat(value) || 0;
    }

    function syncGrid(grid) {
      var cards = Array.prototype.filter.call(grid.children, function (el) {
        return el.classList.contains('product-item') && el.offsetParent !== null && el.querySelector('.product-item__title');
      });

      // Start from a clean slate so every measurement is the card's natural height.
      cards.forEach(function (card) {
        card.style.removeProperty('--title-slack');
        card.style.removeProperty('--usp-slack');
      });

      var rows = [];
      cards.forEach(function (card) {
        var top = Math.round(card.getBoundingClientRect().top + window.pageYOffset);
        var row = rows.length ? rows[rows.length - 1] : null;
        if (!row || Math.abs(row.top - top) > 2) {
          row = { top: top, items: [] };
          rows.push(row);
        }
        var title = card.querySelector('.product-item__title');
        var pill = card.querySelector('.product-item__usp');
        var height = title.offsetHeight;
        if (pill) {
          var style = window.getComputedStyle(pill);
          height += pill.offsetHeight + numeric(style.marginTop) + numeric(style.marginBottom);
        }
        row.items.push({ card: card, hasPill: !!pill, height: height });
      });

      rows.forEach(function (row) {
        var tallest = row.items.reduce(function (max, item) { return Math.max(max, item.height); }, 0);
        row.items.forEach(function (item) {
          var slack = tallest - item.height;
          if (slack > 0.5) {
            item.card.style.setProperty(item.hasPill ? '--usp-slack' : '--title-slack', slack + 'px');
          }
        });
      });
    }

    var queued = false;
    function syncAll() {
      if (queued) return;
      queued = true;
      // A short timer rather than requestAnimationFrame: rAF is paused in background tabs and
      // some embedded webviews, which would leave the row sizing unapplied.
      window.setTimeout(function () {
        queued = false;
        grids.forEach(syncGrid);
      }, 30);
    }

    syncAll();
    window.addEventListener('load', syncAll);
    window.addEventListener('resize', syncAll);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncAll);
    // Filtering, sorting and "load more" re-render the grid's cards.
    grids.forEach(function (grid) {
      new MutationObserver(syncAll).observe(grid, { childList: true });
    });
  })();

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
